import { connectBaseApi, createRpcQuery, createRpcMutation, contactClient } from "@racoon/api";

// A container group's primary contact travels embedded in the pickup-location lists, so
// a contact change refreshes those lists too, or the registry would keep the old one.
const CONTACT_CHANGED = ["Contact" as const, { type: "PickupLocation" as const, id: "LIST" }];

const contactGrpcApi = connectBaseApi.injectEndpoints({
    endpoints: (build) => ({
        listContacts: createRpcQuery(build, contactClient, "listContacts", {
            providesTags: ["Contact"],
        }),

        getContactById: createRpcQuery(build, contactClient, "getContact", {
            providesTags: ["Contact"],
        }),

        createContact: createRpcMutation(build, contactClient, "createContact", {
            invalidatesTags: CONTACT_CHANGED,
        }),

        updateContact: createRpcMutation(build, contactClient, "updateContact", {
            invalidatesTags: CONTACT_CHANGED,
        }),

        deleteContact: createRpcMutation(build, contactClient, "deleteContact", {
            invalidatesTags: CONTACT_CHANGED,
        }),
    }),
    overrideExisting: false,
});

export const { useListContactsQuery, useGetContactByIdQuery, useCreateContactMutation, useUpdateContactMutation, useDeleteContactMutation } = contactGrpcApi;